import client from "./client";

export default {
    async getTenantTickets(filters) {
        return client.parseResponse(await client.get('/tenant-tickets', filters));
    },
    async getTickets(filters) {
        return client.parseResponse(await client.get('/tickets', filters));
    },

    async createTicket(data) {
        return client.parseResponse(await client.post('/tickets', data))
    },

    async createTenantTickets(data) {
        return client.parseResponse(await client.post('/tenant-tickets', data))
    },
    async updateTicketActions(data) {
        return client.parseResponse(await client.post('/ticket-actions', data))
    },
    async sendComment(data) {
        return client.parseResponse(await client.post('/send-ticket-comments', data))
    },
    async sendCommentAdmin(data) {
        return client.parseResponse(await client.post('/send-ticket-comments-admin', data))
    },

    async getTicket(id) {
        return client.parseResponse(await client.get('/tickets/' + id));
    },

    async editTicket(data) {
        return client.parseResponse(await client.put('/tickets/' + data.id, data))
    },

    async editTicketFormData(data) {
        return client.parseResponse(await client.post('/tickets/' + data.get('id') + "?_method=PUT", data, {
            contentType: 'application/x-www-form-urlencoded'
        }))
    },

    async deleteTicket(data) {
        return client.parseResponse(await client.delete('/tickets/' + data.id, data))
    },
    async downloadTicketHistory(filters) {
        return client.parseResponse(await client.get('/download-tickets', filters, {responseType: 'blob'}))
    },

    async exportTicketsReport(filters) {
        return client.parseResponse(await client.get('/export-tickets', filters, {responseType: 'blob'}));
    }
}
